import { colors, screen, fonts } from 'components/styles/variables';
import css from 'styled-jsx/css';
import emailIcon from './email-icon.svg';
import callIcon from './call-icon.svg';
import smsIcon from './sms-icon.svg';

export default css`
  .vehicle-snapshot {
    width: 100%;
    color: ${colors.BLACK};
    margin-top: 8px;
  }

  .request-info-title {
    color: ${colors.BLACK};
    font-family: ${fonts.default};
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0.2px;
    padding-top: 8px;
  }

  .title-container {
    display: flex;
    justify-content: space-between;
  }

  .title {
    max-width: 280px;
    font-size: 21px;
    font-weight: 700;
  }

  @media (min-width: ${screen.smMin}) {
    .title {
      font-size: 24px;
      max-width: 420px;
      margin-bottom: 16px;
    }
  }

  .price {
    text-align: right;
    font-size: 21px;
    font-weight: 700;
    margin-bottom: 1px;
  }

  @media (min-width: ${screen.smMin}) {
    .price {
      font-size: 24px;
      margin-bottom: 7px;
    }
  }

  .monthly-payment {
    font-size: 14px;
    font-weight: 400;
  }

  @media (min-width: ${screen.smMin}) {
    .monthly-payment {
      font-size: 18px;
    }
  }

  .secondary-info {
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${colors.G2};
    padding-bottom: 10px;
  }

  .mileage-mobile {
    font-size: 16px;
    font-weight: 400;
  }

  .mileage-desktop {
    display: none;
  }

  @media (min-width: ${screen.smMin}) {
    .mileage-mobile {
      display: none;
    }

    .mileage-desktop {
      display: block;
      font-size: 18px;
      font-weight: 400;
      padding: 4px 18px 12px 0px;
    }
  }

  .separator {
    padding: 0px 5px;
  }

  .location {
    font-size: 16px;
    font-weight: 400;
  }

  @media (min-width: ${screen.smMin}) {
    .location {
      padding: 4px 0px 12px 18px;
      font-size: 18px;
    }
  }

  .sms-button-container {
    padding-bottom: 16px;
  }

  .sms-button {
    display: flex;
    width: 100%;
    height: 48px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    border-radius: 8px;
    background: ${colors.ALR1};
    color: ${colors.WHITE};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.2px;
    border: none;
  }

  .sms-icon {
    width: 28px;
    height: 28px;
    background-image: url(${smsIcon});
    color: ${colors.WHITE};
    background-size: cover;
    margin-right: 4px;
  }

  .email-icon {
    width: 28px;
    height: 28px;
    background-image: url(${emailIcon});
    background-size: contain;
  }

  .call-icon {
    width: 28px;
    height: 28px;
    background-image: url(${callIcon});
    background-size: contain;
  }

  .contact-button-container {
    display: flex;
    gap: 16px;
  }

  .call-link {
    display: flex;
    color: ${colors.BLACK};
    text-align: center;
    font-family: ${fonts.default};
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.2px;
  }

  .call-button,
  .email-button {
    display: flex;
    flex: 1;
    height: 48px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid ${colors.G2};
    background: ${colors.WHITE};
    color: ${colors.BLACK};
    text-align: center;
    font-family: ${fonts.default};
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.2px;
  }
`;

export const dealerHoursUnavailableCss = css`
  .dealer-hours-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    justify-content: flex-start;
    margin-bottom: 16px;
  }
  .dealer-hours-indicator {
    width: 12px;
    height: 12px;
    background-color: ${colors.G3};
    border-radius: 50%;
  }
  .dealer-hours-text {
    color: ${colors.G3};
    font-family: ${fonts.default};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.2px;
  }
`;

export const dealerHoursAvailableCss = css`
  .dealer-hours-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    justify-content: flex-start;
    margin-bottom: 16px;
  }

  .dealer-hours-indicator {
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }

  .dealer-hours-text {
    font-family: ${fonts.default};
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
    letter-spacing: 0.2px;
  }

  .open-now-indicator {
    background-color: ${colors.ALG1};
  }

  .closed-now-indicator {
    background-color: ${colors.G3};
  }

  .open-now-text {
    color: ${colors.ALG1};
  }

  .closed-now-text {
    color: ${colors.G3};
  }
`;
